import { css } from '@emotion/react';

/*стиль для длинных айфонов, заработает только вместе с правильным вьюпортом и position у родителя*/
export const helperSafeArea = css`
  &:after {
    content: '';
    display: block;
    flex-shrink: 0;
    height: env(safe-area-inset-bottom, 0);
  }
`;
